<div class="asset-storage-form">
  <div>
    <mat-form-field class="form-field" color="accent">
      <mat-label>Destination</mat-label>
      <mat-select [ngModel]="storageTypeId" (ngModelChange)="onStorageTypeChange($event)" required>
        @if (allowNone) {
          <mat-option [value]="noneStorageTypeId">
            {{noneOptionLabel}}
          </mat-option>
        }
        @for (storageType of visibleStorageTypes; track storageType) {
          <mat-option [value]="storageType.id">
            {{storageType.name}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  @if (storageTypeId === dataAddressTypes.httpData) {
    <div>
      <div>
        <mat-form-field class="form-field" color="accent">
          <mat-label>Name</mat-label>
          <input [(ngModel)]="httpDataAddress.name" (ngModelChange)="httpDataAddressChange.emit(httpDataAddress)" matInput required>
        </mat-form-field>
        <mat-form-field class="form-field" color="accent">
          <mat-label>Path</mat-label>
          <input [(ngModel)]="httpDataAddress.path" (ngModelChange)="httpDataAddressChange.emit(httpDataAddress)" matInput>
        </mat-form-field>
        <mat-form-field class="form-field" color="accent">
          <mat-label>Base URL</mat-label>
          <input [(ngModel)]="httpDataAddress.baseUrl" (ngModelChange)="httpDataAddressChange.emit(httpDataAddress)" matInput required>
        </mat-form-field>
        <mat-form-field class="form-field" color="accent">
          <mat-label>Auth Key</mat-label>
          <input [(ngModel)]="httpDataAddress.authKey" (ngModelChange)="httpDataAddressChange.emit(httpDataAddress)" matInput>
        </mat-form-field>
        <mat-form-field class="form-field" color="accent">
          <mat-label>Auth Code</mat-label>
          <input [(ngModel)]="httpDataAddress.authCode" (ngModelChange)="httpDataAddressChange.emit(httpDataAddress)" matInput>
        </mat-form-field>
        <mat-form-field class="form-field" color="accent">
          <mat-label>Secret Name</mat-label>
          <input [(ngModel)]="httpDataAddress.secretName" (ngModelChange)="httpDataAddressChange.emit(httpDataAddress)" matInput>
        </mat-form-field>
        <mat-form-field class="form-field" color="accent">
          <mat-label>Content Type</mat-label>
          <input [(ngModel)]="httpDataAddress.contentType" (ngModelChange)="httpDataAddressChange.emit(httpDataAddress)" matInput>
        </mat-form-field>
      </div>

      <div class="form-field toggle">
        <mat-slide-toggle [ngModel]="httpDataAddress.proxyBody === 'true'" (ngModelChange)="onToggleChange('proxyBody', $event)" color="accent">
          Proxy Body
        </mat-slide-toggle>
      </div>
      <div class="form-field toggle">
        <mat-slide-toggle [ngModel]="httpDataAddress.proxyPath === 'true'" (ngModelChange)="onToggleChange('proxyPath', $event)" color="accent">
          Proxy Path
        </mat-slide-toggle>
      </div>
      <div class="form-field toggle">
        <mat-slide-toggle [ngModel]="httpDataAddress.proxyQueryParams === 'true'" (ngModelChange)="onToggleChange('proxyQueryParams', $event)" color="accent">
          Proxy Query Params
        </mat-slide-toggle>
      </div>
      <div class="form-field toggle">
        <mat-slide-toggle [ngModel]="httpDataAddress.proxyMethod === 'true'" (ngModelChange)="onToggleChange('proxyMethod', $event)" color="accent">
          Proxy Method
        </mat-slide-toggle>
      </div>
    </div>
  }

  @if (storageTypeId === dataAddressTypes.amazonS3 && allowAmazonS3) {
    <div>
      <mat-form-field class="form-field" color="accent">
        <mat-label>Region</mat-label>
        <input required [(ngModel)]="amazonS3DataAddress.region" (ngModelChange)="amazonS3DataAddressChange.emit(amazonS3DataAddress)" matInput>
      </mat-form-field>
      <mat-form-field class="form-field" color="accent">
        <mat-label>Bucket Name</mat-label>
        <input required [(ngModel)]="amazonS3DataAddress.bucketName" (ngModelChange)="amazonS3DataAddressChange.emit(amazonS3DataAddress)" matInput>
      </mat-form-field>
      <mat-form-field class="form-field" color="accent">
        <mat-label>Object Name</mat-label>
        <input required [(ngModel)]="amazonS3DataAddress.objectName" (ngModelChange)="amazonS3DataAddressChange.emit(amazonS3DataAddress)" matInput>
      </mat-form-field>
      <mat-form-field class="form-field" color="accent">
        <mat-label>Key Prefix</mat-label>
        <input [(ngModel)]="amazonS3DataAddress.keyPrefix" (ngModelChange)="amazonS3DataAddressChange.emit(amazonS3DataAddress)" matInput>
      </mat-form-field>
      <mat-form-field class="form-field" color="accent">
        <mat-label>Folder Name</mat-label>
        <input [(ngModel)]="amazonS3DataAddress.folderName" (ngModelChange)="amazonS3DataAddressChange.emit(amazonS3DataAddress)" matInput>
      </mat-form-field>
      <mat-form-field class="form-field" color="accent">
        <mat-label>Access Key Id</mat-label>
        <input required [(ngModel)]="amazonS3DataAddress.accessKeyId" (ngModelChange)="amazonS3DataAddressChange.emit(amazonS3DataAddress)" matInput>
      </mat-form-field>
      <mat-form-field class="form-field" color="accent">
        <mat-label>Secret Access Key</mat-label>
        <input required [(ngModel)]="amazonS3DataAddress.secretAccessKey" (ngModelChange)="amazonS3DataAddressChange.emit(amazonS3DataAddress)" matInput>
      </mat-form-field>
      <mat-form-field class="form-field" color="accent">
        <mat-label>Endpoint Override</mat-label>
        <input required [(ngModel)]="amazonS3DataAddress.endpointOverride" (ngModelChange)="amazonS3DataAddressChange.emit(amazonS3DataAddress)" matInput>
      </mat-form-field>
    </div>
  }

  @if (storageTypeId === dataAddressTypes.inesDataStore && allowInesDataStore) {
    <div>
      <mat-form-field class="form-field" color="accent">
        <mat-label>Folder</mat-label>
        <input [(ngModel)]="inesDataStoreAddress.folder" (ngModelChange)="inesDataStoreAddressChange.emit(inesDataStoreAddress)" matInput>
      </mat-form-field>
      <app-uploader-file (filesChange)="onInesFilesChange($event)"></app-uploader-file>
    </div>
  }
</div>
